import {action, computed, configure, makeObservable, observable, ObservableMap} from 'mobx';
import {GeneralRequester} from './RequestApi/GeneralRequester'
import Utility, {UPLOAD_CHUNK_SIZE} from '../Utility'
import Cookies from 'js-cookie';
import {routes} from "../App";
import {
    contentCreatingRoleEnum,
    deviceTypeEnum,
    responseEnum,
    hpUsersEnum,
    trainingAndFieldRoleEnum,
    administrationRoleEnum,
    workspaceUsersEnum,
    DomainRoutes
} from "../serverClientShared/sharedEnums";
import {dataStore, history, modalStore, projectStore, socketStore} from '../index';
import {DATA_INTERVAL} from "./DataStore";
import Settings from '../settings.json';
import frontlineMobileLogo from '../assets/img/frontlineio-logo-mobile.svg';
import * as sharedUtils from "../serverClientShared/sharedUtils";
import {
    DEVICE_LOGIN_DOMAIN,
    HP_DEVICE_LOGIN_DOMAIN,
    FAST_TRACK_DOMAIN,
    LOGIN_DOMAIN
} from "../serverClientShared/sharedUtils";
import {batchOptions} from "../enums";
import {ProjectRequester} from "./RequestApi/ProjectRequester";
import {v4 as uuidv4} from "uuid";
import localforage from "localforage";

configure({
    enforceActions: "never",
});

function camelize(str) {
    return str?.replace(/^\w|[A-Z]|\b\w/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}

const generalRequest = new GeneralRequester();


const EXPLORE_CARD_WIDTH = 335;
const EXPLORE_CARD_SIDE_MARGIN = 10;
const ONE_DAY = 1000 * 60 * 60 * 24;

const hostSplittedArr = window.location.host.split('.');
let subdomain = null;
if (!['localhost:3002', 'localhost', 'dev', 'procedure', 'demo', 'frontline'].includes(hostSplittedArr[0])) {
    subdomain = hostSplittedArr[0];
}
if (![sharedUtils.FAST_TRACK_DOMAIN, sharedUtils.LOGIN_DOMAIN, sharedUtils.DEVICE_LOGIN_DOMAIN, sharedUtils.HP_DEVICE_LOGIN_DOMAIN, sharedUtils.CONVENTION_LOGIN_DOMAIN, sharedUtils.HP_LOGIN_DOMAIN].includes(subdomain)) {
    if (!Cookies.get('session_active')) {
        Cookies.set('session_active');
        GeneralRequester.sendAnalyticsEvent('session_start_login', subdomain).catch(console.error);
    }
}

const isEmbed = subdomain === sharedUtils.EMBED_DOMAIN //|| hostSplittedArr.length === 4;
const initialDirection = Cookies.get('direction') || 'ltr';
document.body.classList.add(initialDirection);

const setCssVariable = (variableName, value) => {
    document.documentElement.style.setProperty(variableName, value);
};

export class GeneralStore {
    constructor() {
        makeObservable(this, {
            selectedAnimationModelId: observable,
            isOpenFromEditor: observable,
            isPopupNode: observable,
            nodeToAddInteraction: observable,
            onSaveInteractions: observable,
            selectedInteractions: observable,
            selectedNodeId: observable,
            nodeToConnectFrom: observable,
            reactFlowInstance: observable,
            isToManyLoginAttempts: observable,
            isInFullscreen: observable,
            backToSearchText: observable,
            showHelpDesk: observable,
            languageObj: observable,
            globalLanguageExpiration: observable,
            oldMediaFileToBeReplaced: observable,
            oldMediaFilesToBeReplaced: observable,
            newMediaFilesToBeReplaced: observable,
            langDir: observable,
            signInData: observable,
            firstName: observable,
            userIdle: observable,
            isShowPinCode: observable,
            currentTimeStamp: observable,
            dataPollInterval: observable,
            dataPollId: observable,
            pushPollInterval: observable,
            onlinePresenceInterval: observable,
            searchParams: observable,
            directionClassName: observable,
            topProcedures: observable,
            invitedDomains: observable,
            activeDomains: observable,
            projectSearchResults: observable,
            privateProjectsCount: observable,
            publicProjectsCount: observable,
            procedureSearchResults: observable,
            unPublishedProceduresCount: observable,
            publishedProceduresCount: observable,
            publicProceduresCount: observable,
            mediaSearchResults: observable,
            unPublishedMediasCount: observable,
            publishedMediasCount: observable,
            publicMediasCount: observable,
            nullSearch: observable,
            workspace: observable,
            workspaceIsHP: observable,
            isSitePrepEnabled: observable,
            domainSettings: observable,
            domainRoute: observable,
            workspaceManagementData: observable,
            deviceLoginDone: observable,
            deepLinkLoginDone: observable,
            deviceLoginCode: observable,
            userDetails: observable,
            tempFile: observable,
            isLoaderOpen: observable,
            progressLoaderValue: observable,
            progressLoaderString: observable,
            isBlockGeneralLinearModal: observable,
            isProgressLoaderLinear: observable,
            progressIndex: observable,
            uploadedFiles: observable,
            onTheWayOut: observable,
            redirectToAfterLogin: observable,
            isOpenInApp: observable,
            skipValidationForSignup: observable,
            sidebarConstantOpen: observable,
            fabVisible: observable,
            preventLeaveActive: observable,
            loggedIn: observable,
            sliderRefreshProcedureFlag: observable,
            forceStopDataPoll: observable,
            notificationsPanelOpen: observable,
            notificationsSettingsOpen: observable,
            notificationsSettingsCategoryIndex: observable,
            notificationExternalOpen: observable,
            notificationsBtnPressed: observable,
            hideTopBar: observable,
            isWebView: observable,
            payPerClickSharing: observable,
            payPerClickAnalytics: observable,
            fastTrackIsUser: observable,
            fastTrackProjectsList: observable,
            fastTrackCanCreateProjects: observable,
            fastTrackProjectId: observable,
            workspaceUsersSettings: observable,
            workspaceInvitedUsersSettings: observable,
            workspacePendingUsersSettings: observable,
            socketRoomId: observable,
            intercomColor: observable,
            AnimationManagerSelectedFolder:observable,
            progressLoaderModalWithMassageState: observable,
            isProgressLoaderModalWithMassage: observable,
            subWorkspaceDisplayNamesMap: observable,
            sortedTopProcedures: computed,
            contentCreatorRole: computed,
            isWorkspaceOwner: computed,
            isWorkspaceAdmin: computed,
            availableSeats: computed,
            getSubWorkspaceDisplayNames: action,
            getFastTrackProjects: action,
            toggleSidebarConstantOpen: action,
            setIdleState: action,
            logIn: action,
            getDomainsOrLogin: action,
            getDomainsList: action,
            deepLinkLogin: action,
            setLoginState: action,
            startOnlinePresence: action,
            stopOnlinePresence: action,
            dataPoll: action,
            refreshData: action,
            pushPoll: action,
            getPlayerSettings: action,
            getPlayerSettingsFromDB: action,
            verifyUser: action,
            changeEmail: action,
            verifyPassword: action,
            resetPassword: action,
            updatePassword: action,
            selfDestruct: action,
            checkCanDeleteAccount: action,
            deleteAccountCheck: observable,
            getUserName: action,
            refreshCurrentUser: action,
            setLoggedIn: action,
            getSelfUserDetails: action,
            logOut: action,
            deleteToken: action,
            overrideFile: action,
            goToLogin: action,
            uploadFile: action,
            uploadFiles: action,
            zoomLevel: observable,
            updateProgressLoader: action,
            deleteFile: action,
            deleteFolder: action,
            deleteSessionMedia: action,
            renameMediaFolder: action,
            renameFile: action,
            updatePlayerSettings: action,
            getAllNotifications: action,
            getNotificationHeader: action,
            getNotificationDescription: action,
            sortedNotifications: computed,
            openNotificationsPanel: action,
            closeNotificationPanel: action,
            changeNotificationSettings: action,
            numUnreadNotifications: computed,
            markAllNotificationsRead: action,
            updateNotification: action,
            toggleUnread: action,
            deleteManyNotifications: action,
            deleteAllNotifications: action,
            deleteNotification: action,
            checkPreventLeave: action,
            update3DAvatar: action,
            delete3DAvatar: action,
            updateUserHand: action,
            getAllPayPerClicks: action,
            getPayPerClickSessions: action,
            getPayPerClickSessionsChartData: action,
            addPayPerClickToApprovedList: action,
            userCurrentDomainSettings: computed,
            hasAiChatAccess: computed,
            checkWorkspaceAdmin: computed,
            initThemeValues: action,
            translate: action,
            translateRole: action,
            getDomainUsers: action,
            getDomainName: action,
            checkPermission: action,
            theme: observable,
        });

        const sidebarConstantOpenFromCookie = Cookies.get(GeneralStore.SIDEBAR_CONSTANT_OPEN_COOKIE_NAME);
        if (sidebarConstantOpenFromCookie === 'true') {
            this.sidebarConstantOpen = true;
        } else if (sidebarConstantOpenFromCookie === 'false') {
            this.sidebarConstantOpen = false;
        }

        this.getGlobalLanguageFromLocalStorage();
    }

    loginIfOnlyOneWorkspace = async () => {
        if (this.activeDomains.length === 1 && this.invitedDomains.length === 0) {
            this.signInData.workspace = this.activeDomains[0];
            this.signInData.isNewDomain = false;
            await this.logIn();
            return true;
        }
        return false;
    }

    loadLanguageOptions = keyArr => {
        keyArr.forEach(key => this.languageObj.languageOptions.add(key));
    }


    initThemeValues = (theme) => {
        const categories = [
            'Main',
            'ClassicButton',
            'NavigationBar',
            'Panels',
            'Background',
            'WindowsAndMenus',
            'LeaveDeleteNew',
            'OnlineSuccess',
            'DisabledUnselected',
            'CheckBox',
            'Link',
            'InputField',
            'HighlightPart'
        ];

        const borderCategories = [
            'Buttons',
            'Thumbnails',
            'InputFields',
            'PopupWindows',
            'Menus',
            'CheckBox'
        ];

        borderCategories.forEach(borderCategory => {
            setCssVariable(`--${borderCategory.toLowerCase()}-radius`, `${theme?.Radiuses[borderCategory]}px`);
        })

        categories.forEach(category => {
            const categoryPalette = theme?.ColorPalette?.[category];

            if (!categoryPalette) {
                return;
            }

            this.intercomColor = Utility.unityColorToHex(theme?.ColorPalette?.ClassicButton.Normal.Color);

            const states = ['Normal', 'Hovered', 'Pressed', 'Selected', 'Disabled'];

            states.forEach(state => {
                const color = categoryPalette[state]?.Color;
                const textColor = theme?.ContentColors[Utility.mapNumberToFontName(categoryPalette[state]?.contentColor)];
                const borderColor = categoryPalette[state]?.EnableBorder && `1px solid ${Utility.unityColorToHex(categoryPalette[state]?.BorderColor)}`;

                setCssVariable(`--${category.toLowerCase()}-${state.toLowerCase()}-color`, Utility.unityColorToHex(color));
                setCssVariable(`--${category.toLowerCase()}-${state.toLowerCase()}-text-color`, Utility.unityColorToHex(textColor));
                setCssVariable(`--${category.toLowerCase()}-${state.toLowerCase()}-border`, borderColor);
            });
        });
    };

    getGlobalLanguageFromLocalStorage = () => {
        const now = Date.now();
        localforage.getItem('globalLanguageExpiration').then(storedGlobalLanguageExpiration => {
            this.globalLanguageExpiration = parseInt(storedGlobalLanguageExpiration) || 0;
            localforage.getItem('globalLanguageObj').then(item => {
                const storedGlobalLanguageObj = JSON.parse(item);
                if (!!storedGlobalLanguageObj) {
                    this.loadLanguageOptions(storedGlobalLanguageObj.languageOptions);
                    this.languageObj.currentLanguage = storedGlobalLanguageObj.currentLanguage;
                    if (this.globalLanguageExpiration > now) {
                        this.languageObj.langKeys = storedGlobalLanguageObj.langKeys;
                        this.languageObj.globalLoaded = true;
                    } else this.languageObj.globalLoaded = false;
                }
            })
        });
    }

    backToSearchText = '';

    static SIDEBAR_CONSTANT_OPEN_COOKIE_NAME = 'sidebar_constant_open';
    static TASK_REF_COOKIE_NAME = 'task_ref';

    static EXPLORE_CARD_WIDTH = EXPLORE_CARD_WIDTH;
    static EXPLORE_CARD_SIDE_MARGIN = EXPLORE_CARD_SIDE_MARGIN;
    static EXPLORE_CARD_STYLE = {
        width: `${EXPLORE_CARD_WIDTH}px`,
        minWidth: `${EXPLORE_CARD_WIDTH}px`,
        marginLeft: `${EXPLORE_CARD_SIDE_MARGIN}px`,
        marginRight: `${EXPLORE_CARD_SIDE_MARGIN}px`,
        height: '235px'
    };

    reactFlowInstance = null;
    selectedNodeId = "";
    nodeToConnectFrom = null;

    onSaveInteractions = false;
    selectedInteractions = [];
    nodeToAddInteraction = null;
    isPopupNode = false;
    selectedAnimationModelId = null;
    isOpenFromEditor = false;

    isToManyLoginAttempts = false;
    isInFullscreen = false;
    showHelpDesk = true;
    languageObj = {
        languageOptions: new Set(),
        currentLanguage: 'EN',
        langKeys: {
            EN: {
                isRTL: "FALSE"
            }
        },
        domainKeys: {
            EN: {
                isRTL: "FALSE"
            }
        },
        globalLoaded: false,
        domainLoaded: false,
        domainLanguageLastUpdated: null,
        domainLanguageUpdatedBy: "-",
    };
    globalLanguageExpiration = 0;
    oldMediaFileToBeReplaced = null;
    oldMediaFilesToBeReplaced = [];
    newMediaFilesToBeReplaced = [];
    langDir = "ltr";

    signInData = {
        workspace: '',
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        isNewDomain: true,
        ssoAccessToken: '',
        isHpCustomer: false,
    };

    firstName = '';

    currentTimeStamp = Date.now();
    userIdle = false;
    isShowPinCode = true;
    dataPollInterval = null;
    dataPollId = "";
    pushPollInterval = null;
    onlinePresenceInterval = null;

    searchParams = "";
    subWorkspaceDisplayNamesMap = new Map();
    directionClassName = "";

    topProcedures = [];
    invitedDomains = [];
    activeDomains = [];
    domainsDisplayedNames = [];
    invitedDomainNames = new Map();
    activeDomainNames = new Map();
    domainSettings = {};
    domainRoute = DomainRoutes.LIST;
    workspaceManagementData = {};
    theme = {};
    projectSearchResults = [];
    privateProjectsCount = 0;
    publicProjectsCount = 0;

    procedureSearchResults = [];
    unPublishedProceduresCount = 0;
    publishedProceduresCount = 0;
    publicProceduresCount = 0;

    mediaSearchResults = [];
    unPublishedMediasCount = 0;
    publishedMediasCount = 0;
    publicMediasCount = 0;
    nullSearch = false;

    workspace = isEmbed ? Cookies.get('workspace') : subdomain;
    workspaceName = this.workspace;
    workspaceIsHP = !!this.workspace && ([sharedUtils.HP_LOGIN_DOMAIN, sharedUtils.HP_DEVICE_LOGIN_DOMAIN, sharedUtils.HP_API_DOMAIN].includes(this.workspace));
    isSitePrepEnabled = false;
    isTranslationAiEnabled = false;

    isObjectDetectionEnabled = false;
    AnimationManagerSelectedFolder = null;
    deviceLoginDone = false;
    deepLinkLoginDone = false;
    deviceLoginCode = '';

    userDetails = {};
    tempFile = "";
    isLoaderOpen = false;
    progressLoaderValue = null;
    progressLoaderString = '';
    isProgressLoaderLinear = true
    progressIndex = 0;
    uploadedFiles = [];

    onTheWayOut = false;
    redirectToAfterLogin = '';
    isOpenInApp = false;
    skipValidationForSignup = false;
    sidebarConstantOpen = !Utility.isMobile();
    fabVisible = true;
    preventLeaveActive = false;

    loggedIn = false;
    sliderRefreshProcedureFlag = false;
    forceStopDataPoll = false;
    notificationsPanelOpen = false;
    notificationsSettingsOpen = false;
    notificationsSettingsCategoryIndex = 0;
    notificationExternalOpen = false;
    notificationsBtnPressed = false;
    hideTopBar = false;
    isWebView = false;
    intercomColor = null;
    zoomLevel = Math.ceil(((window.outerWidth - 10) / window.innerWidth) * 100);
    fastTrackIsUser = false;
    fastTrackProjectsList = [];
    fastTrackCanCreateProjects = false;
    fastTrackProjectId = null;
    progressLoaderModalWithMassageState = {value: 0, message: ''};
    isProgressLoaderModalWithMassage= false
    isBlockGeneralLinearModal = false
    

    workspaceUsersSettings = {
        sortBy: 'administrationRole',
        sortAscending: false,
    }

    workspaceInvitedUsersSettings = {
        sortBy: 'administrationRole',
        sortAscending: false,
    }

    workspacePendingUsersSettings = {
        sortBy: 'administrationRole',
        sortAscending: false,
    }

    payPerClickSharing = {
        creationDate: -1,
        expirationDate: -2,
        status: 'all',
        approvedSortBy: 'CreationDate',
        approvedSortDirection: -1,
        pendingSortBy: 'RequestGenerated',
        pendingSortDirection: -1,
        payPerClicks: [],
        pendingPayPerClicks: [],
        pageNumber: 0,
        total: 0,
        batchIndex: 0,
        loadingApproved: false,
        loadingPending: false,
    };

    payPerClickAnalytics = {
        startDate: -1,
        sortBy: 'StartTimeStamp',
        sortDirection: -1,
        payPerClickSessions: [],
        pageNumber: 0,
        total: 0,
        batchIndex: 0,
        loading: false,
        dailyData: [],
        weeklyData: [],
        monthlyData: [],
        dateFrom: new Date(Date.now() - ONE_DAY * 30),
        dateTo: new Date(),
    };

    
    

    socketRoomId = "";
    setReactFlowInstance = instance => this.reactFlowInstance = instance;

    get userCurrentDomainSettings() {
        return !!this.workspace && !!this.userDetails?.Domains ? this.userDetails.Domains[this.workspace] : null;
    }

    get sortedTopProcedures() {
        return this.topProcedures.slice().sort((a, b) => b.views - a.views)
    }

    get isWorkspaceOwner() {
        return this.userDetails.Domains?.[this.workspace]?.IsWorkspaceOwner;
    }

    get isWorkspaceAdmin() {
        return this.userDetails.Domains?.[this.workspace]?.Roles?.AdministrationRole === workspaceUsersEnum.WORKSPACE_ADMIN;
    }

    get availableSeats() {
        const memberCounts = this.domainSettings?.MembersCount ?? 1
        const remainingSeats = this.domainSettings?.MaxUsers - memberCounts
        return Math.max(remainingSeats, 0);
    }

    get contentCreatorRole() {
        return this.userDetails?.Domains?.[this.workspace]?.Roles?.ContentCreationRole;
    }

    get hasAiChatAccess () {
        const isAdmin = this.userDetails?.Domains?.[this.workspace].IsWorkspaceOwner || this.isWorkspaceAdmin;
        const isHaveARole = this.userDetails?.Domains?.[this.workspace]?.Roles?.ContentCreationRole !== 'none' || this.userDetails?.Domains?.[this.workspace]?.Roles?.TrainingAndFieldRole !== 'none'
        return isAdmin || isHaveARole;
    }

    getFastTrackProjects = async (workspace) => {
        const {email, password} = this.signInData;
        const {
            canCreateProjects,
            projectsList
        } = await ProjectRequester.getFastTrackProjects(workspace, email, password);
        this.fastTrackProjectsList = projectsList;
        this.fastTrackCanCreateProjects = canCreateProjects;
    }

    setGlobalLanguage = async () => {
        if (!!Settings.isOnPrem) {
            return;
        }
        if (!this.languageObj.globalLoaded) {
            await this.getGlobalLanguage(this.languageObj.currentLanguage);
        }
        this.setLangDir();
    }

    setLangDir = () => {
        document.body.classList.remove('rtl', 'ltr');
        const direction = this.translate("isRTL") === "TRUE" ? 'rtl' : 'ltr';
        document.body.classList.add(direction);
        this.langDir = direction;
        Cookies.set('direction', direction)
    }

    globalSearch = async (term) => {
        const workspace = this.workspace
        return await GeneralRequester.globalSearch(term, workspace);
    }

    globalSearchAccess = async () => {
        const workspace = this.workspace
        return await GeneralRequester.globalSearchAccess(workspace);
    }

    globalSearchCleanCache = async () => {
        const workspace = this.workspace
        return await GeneralRequester.globalSearchCleanCache(workspace);
    }

    globalSearchGetFullPath = async (folderId) => {
        const workspace = this.workspace
        return await GeneralRequester.globalSearchGetFullPath(workspace, folderId);
    }

    translateRole = (role, firstLetterSmall = false) => {
        if (role === trainingAndFieldRoleEnum.OPERATOR_3D) {
            return 'Operator MR';
        } else {
            return this.translate(role, firstLetterSmall);
        }
    }

    blurIntercom = () => {
    }

    getDomainUsers = async (searchStr, ignoreIds) => {
        return await GeneralRequester.getDomainUsers(this.workspace, searchStr, ignoreIds);
    }

    checkToManyLoginAttempts = async (email) => {
        const {status} = await GeneralRequester.checkToManyLoginAttempts(email);

        this.isToManyLoginAttempts = status.isLocked;

        return status.isLocked;
    }

    translate = (key, firstLetterSmall = false) => {
        key = camelize(key);
        const lang = this.languageObj.currentLanguage;
        let retVal;
        if (!!this.languageObj?.domainKeys && !!this.languageObj.domainKeys[lang] && !!this.languageObj.domainKeys[lang][key]) {    //check currently loaded workspace language first
            retVal = this.languageObj.domainKeys[lang][key];
        } else if (!!this.languageObj?.langKeys && !!this.languageObj.langKeys[lang] && !!this.languageObj.langKeys[lang][key]) {  //fallback to general language
            retVal = this.languageObj.langKeys[lang][key];
        } else if (!!this.languageObj?.langKeys && !!this.languageObj.langKeys["EN"] && !!this.languageObj.langKeys["EN"][key]) {   //English fallback
            retVal = this.languageObj.langKeys["EN"][key];
        }
        if (retVal) {
            if (firstLetterSmall) {
                retVal = retVal.toLowerCase()
            }
            return retVal;
        }
        if (key === 'dateLocale') {
            return "en-US"
        }
        // console.debug('Missing translation for', key);
        const camelCase = key?.replace(/([A-Z])/g, ' $1');
        // noinspection UnnecessaryLocalVariableJS
        const capital = !firstLetterSmall ? sharedUtils.strToCapital(camelCase) : camelCase.toLowerCase();
        return capital;
    }

    getSSO = async () => {
        const isOwner = this.isWorkspaceOwner
        const sso = await GeneralRequester.getSSO(this.workspace);
        const isActive = sso.isActive
        return sso?.sso ? {sso, isActive, isOwner} : {sso: {}, isActive, isOwner}
    }

    updateSSO = async (Description, TenantId, Signature, _id, isDefault, LogUrl, TokenUrl, UserInfoUrl) => {
        const Key = this.workspace
        return await GeneralRequester.updateSSO(Key, Description, TenantId, Signature, _id, isDefault, LogUrl, TokenUrl, UserInfoUrl);
    }
    removeSSO = async (_id) => {
        const workspace = this.workspace
        return await GeneralRequester.removeSSO(workspace, _id);
    }

    getIsUserSSO = async (email) => {
        await this.checkToManyLoginAttempts(email);
        return await GeneralRequester.getIsUserSSO(email, this.deviceLoginCode);
    }

    isRtl = () => {
        return this.translate('isRTL') === 'TRUE'
    }

    getGlobalLanguage = async langVar => {
        let globalLanguages;
        try {
            globalLanguages = await GeneralRequester.getGlobalLanguage();
        } catch (e) {
            console.error(e);
        }
        if (!!globalLanguages) {
            const globalLanguageObj = {
                languageOptions: Object.keys(globalLanguages),
                currentLanguage: langVar,
                langKeys: globalLanguages
            };

            this.loadLanguageOptions(globalLanguageObj.languageOptions);
            this.languageObj.currentLanguage = langVar;
            this.languageObj.langKeys = globalLanguages;
            this.languageObj.globalLoaded = true;
            const newExpiration = Date.now() + ONE_DAY;
            this.globalLanguageExpiration = newExpiration;

            localforage.setItem('globalLanguageExpiration', JSON.stringify(newExpiration))
                .then()
                .catch(e => console.error('could not store in localstorage', e));
            localforage.setItem('globalLanguageObj', JSON.stringify(globalLanguageObj))
                .then()
                .catch(e => console.error('could not store in localstorage', e));
        }
    }

    switchLanguage = async lang => {
        await this.getGlobalLanguage(lang);
        if (!!this.workspace && !!this.loggedIn) {
            const domainLanguage = await this.getDomainLanguageFromServer();
            if (!!domainLanguage) {
                this.setDomainLanguage(domainLanguage, lang)
            }
        }
        this.setLangDir();
    }

    uploadDomainLanguageTable = async langArr => {
        const currentLang = this.languageObj.currentLanguage
        const domainLanguage = await GeneralRequester.uploadDomainLanguage(this.workspace, langArr);
        if (!!domainLanguage) {
            this.setDomainLanguage(domainLanguage, currentLang);
            this.setLangDir();
            return true
        }
    }

    setDomainLanguage = (domainLanguage, currentLanguage) => {
        const domainKeys = domainLanguage.languages;
        const domainLanguageObj = {
            lastUpdated: domainLanguage.LastUpdated,
            updatedBy: domainLanguage.UpdatedBy,
            languageOptions: domainLanguage.languageOptions,
            currentLanguage: currentLanguage,
            domainKeys
        }

        this.loadLanguageOptions(domainLanguage.languageOptions);
        this.languageObj.currentLanguage = currentLanguage;
        this.languageObj.domainKeys = domainKeys;

        const newExpiration = Date.now() + ONE_DAY;
        this.globalLanguageExpiration = newExpiration;
        this.languageObj.domainLanguageLastUpdated = domainLanguage.LastUpdated;
        this.languageObj.domainLanguageUpdatedBy = domainLanguage.UpdatedBy;
        this.languageObj.domainLoaded = true;

        localforage.setItem('globalLanguageExpiration', JSON.stringify(newExpiration))
            .then()
            .catch(e => console.error('could not store in localstorage', e));
        localforage.setItem('domainLanguageObj', JSON.stringify(domainLanguageObj))
            .then()
            .catch(e => console.error('could not store in localstorage', e));
    }

    loadDomainLanguageFromLocalStorage = () => {
        const now = Date.now();
        localforage.getItem('globalLanguageExpiration').then(async storedGlobalLanguageExpiration => {
            this.globalLanguageExpiration = parseInt(storedGlobalLanguageExpiration) || 0;
            const storedGlobalLanguageObj = JSON.parse(await localforage.getItem('globalLanguageObj'));
            const storedDomainLanguageObj = JSON.parse(await localforage.getItem('domainLanguageObj'));
            if (!!storedDomainLanguageObj && !!storedGlobalLanguageObj) {
                this.loadLanguageOptions(storedDomainLanguageObj.languageOptions);
                if (this.globalLanguageExpiration > now) {
                    this.languageObj.domainKeys = storedDomainLanguageObj.domainKeys;
                    this.languageObj.domainLanguageLastUpdated = storedDomainLanguageObj.lastUpdated;
                    this.languageObj.domainLanguageUpdatedBy = storedDomainLanguageObj.updatedBy;
                    this.languageObj.domainLoaded = true;
                }
            }
        });
    }

    loadDomainLanguage = async () => {
        this.loadDomainLanguageFromLocalStorage();
        if (!this.languageObj.domainLoaded) {  //if it did not load from local storage (not saved or date expired) then get from db
            const domainLanguage = await this.getDomainLanguageFromServer();
            if (!!domainLanguage) {
                this.setDomainLanguage(domainLanguage, this.languageObj.currentLanguage)
            }
        }
    }

    getDomainLanguageFromServer = async () => {
        try {
            const {domainLanguage, message} = await GeneralRequester.getDomainLanguage(this.workspace);
            if (!domainLanguage) {
                console.warn(message)
            } else return domainLanguage
        } catch (e) {
            console.warn("Domain language table not found.")
        }
    }

    getDomainLanguage = async () => {
        if (!this.languageObj.domainLoaded) {
            await this.loadDomainLanguage();
        }
        this.setLangDir();
    }

    downloadDomainLanguage = async () => {
        return await GeneralRequester.downloadDomainLanguage(this.workspace);
    }

    resetLanguages = () => {
        this.languageObj.domainKeys = {
            EN: {
                isRTL: "FALSE"
            }
        }
        this.languageObj.domainLoaded = false;
        this.getGlobalLanguageFromLocalStorage();
        this.setGlobalLanguage().then()
    }

    toggleSidebarConstantOpen = () => {
        this.sidebarConstantOpen = !this.sidebarConstantOpen;
        Cookies.set(GeneralStore.SIDEBAR_CONSTANT_OPEN_COOKIE_NAME, this.sidebarConstantOpen);
    };

    setIdleState = idleState => {
        this.userIdle = idleState;
        console.log(`Entering ${idleState ? "idle" : "active"} state.`);
        if (!idleState) {
            this.dataPoll().then();
        }
    };

    logIn = async () => {
        const {
            email,
            password,
            workspace,
            isNewDomain,
            ssoAccessToken,
            isHpCustomer,
            ssoAuth,
            firstName,
            lastName
        } = this.signInData;
        try {
            const isDeviceLogin = !!this.deviceLoginCode || this.workspace === sharedUtils.DEVICE_LOGIN_DOMAIN || this.workspace === sharedUtils.HP_DEVICE_LOGIN_DOMAIN;
            if (isDeviceLogin) {
                await GeneralRequester.loginDevice(this.deviceLoginCode, email, password, workspace, isNewDomain, ssoAccessToken, isHpCustomer, ssoAuth, firstName, lastName);
                this.deviceLoginDone = true;
                this.workspace = this.workspaceIsHP ? sharedUtils.HP_DEVICE_LOGIN_DOMAIN : sharedUtils.DEVICE_LOGIN_DOMAIN;
                return;
            }

            const isChangeEmail = this.redirectToAfterLogin === routes.CHANGE_EMAIL;
            const deviceType = deviceTypeEnum.WEB;
            const {user} = await GeneralRequester.logIn(email, password, isChangeEmail, deviceType, workspace, isNewDomain, ssoAccessToken, isHpCustomer, ssoAuth, firstName, lastName);
            if (user) {
                if (isNewDomain) {
                    history.push(routes.WAITING_WORKSPACE);
                } else {
                    this.userDetails = user;
                    if (this.workspace === sharedUtils.FAST_TRACK_DOMAIN) {
                        return;
                    }
                    const previousWorkspace = this.workspace;
                    this.workspace = workspace;
                    this.dataPollId = this.userDetails.DataUpdateId;
                    this.resetSignInData();
                    this.setLoginState();
                    this.setWorkspaceConfig().then();
                    this.updateUserLastLogin();
                    if (this.isOpenInApp) {
                        await this.deepLinkLogin();
                        return;
                    }
                    let redirectTo = '';
                    if (Settings.isNative) {
                        redirectTo += '#';
                    }

                    redirectTo += this.redirectToAfterLogin ? this.redirectToAfterLogin : routes.MAIN_DASHBOARD;
                    await this.gotoSubdomain(redirectTo, previousWorkspace);
                }
            } else {
                throw new Error('no user returned');
            }
        } catch (e) {
            if (isNewDomain && e.response.status === responseEnum.BLOCKED) {
                history.push(routes.WAITING_WORKSPACE);
                return;
            }
            throw e;
        }
    };

    getDomainName = (domainId, isInvited = false) => this[isInvited ? 'invitedDomainNames' : 'activeDomainNames'].get(domainId) || domainId;

    getDomainsList = async (verificationResult = '') => {
        const {email, password, ssoAuth, isHpCustomer, ssoAccessToken} = this.signInData;
        let hpUserType = hpUsersEnum.NONE;
        if (this.workspaceIsHP) {
            if (isHpCustomer) {
                hpUserType = hpUsersEnum.CUSTOMER;
            } else {
                hpUserType = hpUsersEnum.EMPLOYEE;
            }
        }
        const {
            activeDomains,
            domainsDisplayedNames,
            invitedDomains,
            invitedDomainNames,
            activeDomainNames,
            returnEmail,
            ssoAccessToken: returnedSsoAccessToken,
        } = await GeneralRequester.getDomains(email, password, ssoAuth, hpUserType, ssoAccessToken, verificationResult);
        this.activeDomains = activeDomains;
        this.domainsDisplayedNames = domainsDisplayedNames;
        this.activeDomainNames = new Map(activeDomainNames?.filter(activeDomain => !!activeDomain).map(activeDomain => [activeDomain.DomainName, activeDomain.UserSpecifiedName]));
        this.invitedDomains = invitedDomains;
        this.invitedDomainNames = new Map(invitedDomainNames?.filter(invitedDomain => !!invitedDomain).map(invitedDomain => [invitedDomain.DomainName, invitedDomain.UserSpecifiedName]));
        this.signInData.email = returnEmail;
        this.signInData.ssoAccessToken = returnedSsoAccessToken;
    }
    getDomainsDisplayedName = (domainId) => (this.domainsDisplayedNames.find(domain => domain.Workspace === domainId))?.WorkspaceDisplayedName || domainId;
    getDomainsOrLogin = async (verificationResult = '') => {
        const urlParams = new URLSearchParams(window.location.search);
        const hpAuthCode = urlParams.get('code');
        const hpStateParam = urlParams.get('state');
        let hpStateParamList = [];
        let hpState;
        const stateParams = {};
        if (!!hpStateParam) {
            hpStateParamList = hpStateParam.split('_');
            hpState = hpStateParamList.shift();
            hpStateParamList.forEach(stateParamPair => {
                const stateParamArr = stateParamPair.split('=');
                stateParams[stateParamArr[0]] = stateParamArr[1];
            });
            this.isOpenInApp = stateParams.openapp === '1';
        }

        const isValidHP = hpAuthCode && hpState === Settings.hp.state;
        if (isValidHP) {
            if (stateParams.devicecode) {
                this.deviceLoginCode = stateParams.devicecode;
            }
            this.signInData.ssoAuth = hpAuthCode;
            this.signInData.isHpCustomer = stateParams.customer === '1';
            if (!!stateParams.redirect) {
                const goToHpWorkspace = ![sharedUtils.LOGIN_DOMAIN, sharedUtils.FAST_TRACK_DOMAIN, sharedUtils.DEVICE_LOGIN_DOMAIN, sharedUtils.HP_DEVICE_LOGIN_DOMAIN, sharedUtils.HP_LOGIN_DOMAIN].includes(stateParams.workspace);
                if (goToHpWorkspace) {
                    this.signInData.isNewDomain = false;
                    this.signInData.workspace = stateParams.workspace;
                    this.redirectToAfterLogin = stateParams.redirect;
                    if (stateParams.emailToInvite) {
                        this.redirectToAfterLogin += '?email=' + stateParams.emailToInvite;
                    }
                    try {
                        await this.logIn();
                        return false;
                    } catch (e) {
                        if (e.response.status === responseEnum.TOO_MANY_REQUESTS) {
                            modalStore.modalData = {
                                connections: e.response.data.connectionsList,
                                maxConnectionsPerUser: e.response.data.maxConnectionsPerUser,
                                confirmText: 'login',
                                confirmCallback: () => {
                                    modalStore.isTooManyConnectionsModalOpen = false;
                                    this.logIn();
                                }
                            };
                            modalStore.isTooManyConnectionsModalOpen = true;
                        }
                    }
                } else {
                    await this.getDomainsList(verificationResult);
                    return true;
                }
            }
        }
        const goToWorkspace = ![sharedUtils.LOGIN_DOMAIN, sharedUtils.FAST_TRACK_DOMAIN, sharedUtils.DEVICE_LOGIN_DOMAIN, sharedUtils.HP_DEVICE_LOGIN_DOMAIN, sharedUtils.HP_LOGIN_DOMAIN].includes(this.workspace);
        if (goToWorkspace) {
            this.signInData.isNewDomain = false;
            this.signInData.workspace = this.workspace;
            await this.logIn();
            return false;
        } else {
            await this.getDomainsList(verificationResult);
            const didLogin = await this.loginIfOnlyOneWorkspace();
            return !didLogin;
        }
    };

    async gotoSubdomain(redirectTo, previousDomain) {
        let queryString = '';
        queryString += this.redirectToAfterLogin ? ('redirect=' + encodeURIComponent(this.redirectToAfterLogin)) : '';
        if (previousDomain === this.workspace || isEmbed) {
            Cookies.set('workspace', this.workspace, {expires: 365});
            const separator = redirectTo.includes('?') ? '&' : '?';
            window.location.href = `${redirectTo}${queryString ? separator + queryString : ''}`;
            return;
        }
        this.isLoaderOpen = true;
        const {protocol} = window.location;
        const fullDomain = Utility.getFullDomain(this.workspace, previousDomain);
        const tempToken = await GeneralRequester.getTempToken();
        queryString += (queryString ? '&' : '') + 't=' + tempToken + '&d=' + Cookies.get('deviceId_v2');
        const separator = redirectTo.includes('?') ? '&' : '?';
        window.location.href = `${protocol}//${fullDomain}${redirectTo}${separator}${queryString}`;
    }

    deepLinkLogin = async () => {
        const tempToken = await GeneralRequester.getTempToken();
        window.location.href = `frn://frontline-ar?w=${this.workspace}&t=${tempToken}`;
        this.deepLinkLoginDone = true;
    };

    setLoginState = () => {
        this.loggedIn = true;
        if ([sharedUtils.LOGIN_DOMAIN, sharedUtils.FAST_TRACK_DOMAIN, sharedUtils.DEVICE_LOGIN_DOMAIN, sharedUtils.HP_DEVICE_LOGIN_DOMAIN].includes(this.workspace)) {
            return;
        }
        if (!Settings.dataPollInterval) {
            console.error('cannot set data polling, interval is too big')
        }
        this.dataPollInterval = setInterval(this.dataPoll, Settings.dataPollInterval * 1000);
        this.pushPollInterval = setInterval(this.pushPoll, Settings.dataPollInterval * 6000);
        this.dataPoll().then();
        this.pushPoll().then();
        this.getDomainLanguage().then();
        this.startOnlinePresence();
        socketStore.subscribeForIncomingCalls(this.userDetails);
    };

    startOnlinePresence = () => {
        if (this.onlinePresenceInterval) {
            return;
        }
        const tick = () => {
            GeneralRequester.updateOnline().catch(() => {
                // Silent — presence isn't critical for core functionality
            });
        };
        tick();
        this.onlinePresenceInterval = setInterval(tick, 15 * 1000);
    };

    stopOnlinePresence = () => {
        if (this.onlinePresenceInterval) {
            clearInterval(this.onlinePresenceInterval);
            this.onlinePresenceInterval = null;
        }
    };

    checkDomainLegal = async () => {
        const {isNewDomain, workspace} = this.signInData;
        return await GeneralRequester.checkDomainLegal(isNewDomain, workspace);
    }

    resendVerificationCode = async () => {
        const {email} = this.signInData;
        return await GeneralRequester.resendVerificationCode(email);
    }

    checkNoPolling = () => {
        if ([sharedUtils.LOGIN_DOMAIN, sharedUtils.HP_LOGIN_DOMAIN].includes(this.workspace)) {
            return true;
        }
        const userId = this.userDetails._id;
        const path = window.location.pathname;
        const editorMatchStr = Utility.buildUrl(routes.EDITOR, {
            db: '(.*)',
            projectId: '(.*)',
            procedureId: '(.*)',
        });

        const embeddedPlayerMatchStr = Utility.buildUrl(routes.EMBEDDED_PLAYER, {
            db: '(.*)',
            record: '(.*)',
            procedureId: '(.*)',
        });

        const viewerMatchStr = Utility.buildUrl(routes.VIEWER, {
            db: '(.*)',
            record: '(.*)',
            procedureId: '(.*)',
        });
        const isInEditor = !!path.match(editorMatchStr);
        const isInEmbeddedPlayer = !!path.match(embeddedPlayerMatchStr);
        const isInViewerPlayer = !!path.match(viewerMatchStr);

        return isInEditor ||
            isInEmbeddedPlayer ||
            isInViewerPlayer ||
            this.forceStopDataPoll ||
            this.userIdle ||
            !userId ||
            !this.workspace ||
            this.workspace === FAST_TRACK_DOMAIN ||
            this.workspace === DEVICE_LOGIN_DOMAIN ||
            this.workspace === HP_DEVICE_LOGIN_DOMAIN;
    }

    dataPoll = async () => {
        this.currentTimeStamp = Date.now();
        if (this.checkNoPolling()) {
            return;
        }

        try {
            const {
                dataUpdateId,
                forceDisconnect
            } = await GeneralRequester.dataPoll(this.workspace, this.userDetails._id);
            if (forceDisconnect) {
                modalStore.isKickedOutModalOpen = true;
                return;
            }
            if (!this.dataPollId) {
                this.dataPollId = dataUpdateId;
            }
            if (dataUpdateId !== this.dataPollId) {
                dataStore.projectsDataExpiration = Date.now() - 1;
                dataStore.notificationsDataExpiration = Date.now() - 1;
                try {
                    await this.refreshData();
                    this.dataPollId = dataUpdateId;
                } catch (e) {
                    history.push(routes.NOT_FOUND);
                    dataStore.projectsDataExpiration = Date.now() - 1;
                }
            }
        } catch (e) {
            console.log("workspace", this.workspace);
            if (e.response && e.response.status === responseEnum.NOT_EXISTS) {
                modalStore.isKickedOutModalOpen = true;
            } else {
                console.error('cannot fetch data poll', e);
            }
        }

    };

    refreshData = async () => {
        const timeStr = Utility.renderTime_HHMM(new Date());
        console.log('%c ' + timeStr + ' - REFRESHING DATA ', 'text-shadow: 0 0 2px #000; color: white; background-image: linear-gradient(red, orange, yellow, green, blue, purple); font-weight: bolder');
        this.getAllNotifications().then();

        const projectId = projectStore.currentProject?.ProjectIdentifier;
        if (projectId) {
            await projectStore.setCurrentProjectDetails(projectId, true);
        }
    };

    pushPoll = async () => {
        if (!this.userIdle) {    //only runs if user is idle
            return
        }
        try {
            const {success} = await GeneralRequester.getNewPushNotifications(this.workspace);
            if (!!success) {
                dataStore.notificationsDataExpiration = Date.now() - 1;
                await this.getAllNotifications();
            }
        } catch (e) {
            if (e.response && e.response.status === responseEnum.NOT_EXISTS) {
                modalStore.isKickedOutModalOpen = true;
            } else {
                console.error('cannot fetch data poll', e);
            }
        }
    };

    getPlayerSettingsFromDB = async () => {
        const {
            WebBackgroundColorRight,
            WebBackgroundColorLeft,
            WebBackgroundImageAddress,
            WebIsBackgroundColor,
            MobileBackgroundColorTop,
            MobileBackgroundColorBottom,
            MobileTopBarColor,
            MobileBottomBarColor,
            MobileBackgroundImageAddress,
            MobileIsBackgroundColor,
            QRLogoImageAddress,
            IsStreamable,
            QRBorderColor,
            QRTopImageAddress
        } = await GeneralRequester.getPlayerSettings(this.workspace);

        dataStore.playerSettings = {
            webBackgroundColorRight: WebBackgroundColorRight,
            webBackgroundColorLeft: WebBackgroundColorLeft,
            webBackgroundImageAddress: WebBackgroundImageAddress,
            webIsBackgroundColor: WebIsBackgroundColor,
            mobileBackgroundColorTop: MobileBackgroundColorTop,
            mobileBackgroundColorBottom: MobileBackgroundColorBottom,
            mobileTopBarColor: MobileTopBarColor,
            mobileBottomBarColor: MobileBottomBarColor,
            mobileBackgroundImageAddress: MobileBackgroundImageAddress,
            mobileIsBackgroundColor: MobileIsBackgroundColor,
            qrLogoImageAddress: QRLogoImageAddress,
            isStreamable: IsStreamable,
            qrBorderColor: QRBorderColor,
            qrTopImageAddress: QRTopImageAddress
        }
    }

    getPlayerSettings = async () => {
        const isExpired = Date.now() > dataStore.playerSettingsDataExpiration;
        if (isExpired) {
            dataStore.playerSettingsDataExpiration = Date.now() + DATA_INTERVAL;
            await this.getPlayerSettingsFromDB();
        }
        return dataStore.playerSettings;
    };

    signUp = async () => {
        const deviceType = deviceTypeEnum.WEB;
        try {
            const {email, password, firstName, lastName, workspace, isNewDomain} = this.signInData;
            const user = await GeneralRequester.signup(email, password, firstName, lastName, workspace, isNewDomain, deviceType);
            if (this.workspace === FAST_TRACK_DOMAIN) {
                this.userDetails = user;
                return;
            }
            if (user) {
                this.userDetails = user;
                const previousWorkspace = this.workspace;
                this.workspace = workspace;
                this.dataPollId = this.userDetails.DataUpdateId;
                this.resetSignInData();
                this.setLoginState();

                if (isNewDomain) {
                    GeneralRequester.sendAnalyticsEvent('workspace_created', workspace).catch(console.error);
                }

                await this.gotoSubdomain(routes.MAIN_DASHBOARD, previousWorkspace);
            } else {
                throw new Error('no user returned');
            }
        } catch (e) {
            if (e.response.status === responseEnum.BLOCKED) {
                if (this.workspace === FAST_TRACK_DOMAIN) {
                    this.workspace = LOGIN_DOMAIN
                }
                history.push(routes.WAITING_WORKSPACE);
                return;
            }
            throw e;
        }
    };

    createPendingUser = async () => {
        const {email, firstName, lastName} = this.signInData;
        await GeneralRequester.createPendingUser(email, firstName, lastName);
    };

    verifyUser = async (verificationCode, isConvention = false) => {
            const deviceType = deviceTypeEnum.WEB;
            const {email, password, firstName, lastName} = this.signInData;
            if (isConvention) {
            const {conventionWorkspace: workspace, conventionProjects} = Settings;
            if (!this.userDetails.selectedConventionProjectIds) {
                this.userDetails.selectedConventionProjectIds = !!conventionProjects ? Object.keys(conventionProjects).slice(0, 1) : []
            }
            if (!workspace) {
                throw new Error('no convention workspace')
            }
            const user = await GeneralRequester.verifyAndCreateConventionUser(verificationCode, workspace, email, password, firstName, lastName, this.userDetails.selectedConventionProjectIds, deviceType);
            if (user) {
                this.userDetails = user;
                this.loggedIn = true;
            } else {
                throw new Error('no user returned');
            }
        } else {
            this.invitedDomains = await GeneralRequester.verifyUser(email, password, firstName, lastName, verificationCode, deviceType);
            const invitedDomainNames = await GeneralRequester.getDomainNames(this.invitedDomains);
            this.invitedDomainNames = new Map(invitedDomainNames.map(invitedDomain => [invitedDomain.DomainName, invitedDomain.UserSpecifiedName]));
        }
    };

    changeEmail = async (newEmail) => {
        // noinspection UnnecessaryLocalVariableJS
        const status = await generalRequest.changeEmail(this.userDetails.Email, newEmail, this.workspaceIsHP);
        return status;
    };

    finishChangeEmail = async () => {
        return await generalRequest.finishChangeEmail(this.userDetails._id, this.workspace);
    };

    verifyPassword = () => {
        const {
            message,
            success
        } = Utility.verifyAndMessagePassword(this.signInData.password, this.signInData.confirmPassword);
        if (!success) {
            modalStore.showErrorMessage(message);
        }
        return success;
    };

    resetPassword = async (verificationResult) => {
        await GeneralRequester.resetPassword(this.signInData.email, verificationResult);
    };

    updatePassword = async (token) => {
        await GeneralRequester.updatePassword(this.signInData, token);
        this.resetSignInData();
    };

    resetSignInData = () => {
        this.signInData = {
            workspace: '',
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            confirmPassword: "",
            isNewDomain: true,
            ssoAccessToken: '',
            isHpCustomer: false,
        }
    };

    deleteAccountCheck = {canDelete: true, ownedWorkspaces: []};

    checkCanDeleteAccount = async () => {
        try {
            this.deleteAccountCheck = await GeneralRequester.canDeleteAccount(this.workspace);
        } catch (e) {
            console.error(e);
            this.deleteAccountCheck = {canDelete: true, ownedWorkspaces: []};
        }
    };

    selfDestruct = async () => {
        const success = await GeneralRequester.deleteUser(this.userDetails._id, this.workspace);
        if (success) {
            await this.logOut();
            return true;
        }
        return false;
    };

    getUserName = async (id) => {
        if (!this.workspace) {
            return null;
        }
        if (!id) {
            return null;
        }
        const user = await generalRequest.getUserById(id, this.workspace);
        return `${user.Name} ${user.LastName}`
    };

    refreshCurrentUser = async () => {
        this.userDetails = await this.getSelfUserDetails();
    };
    setLoggedIn = async (token) => {
        if (!this.workspace) {
            this.loggedIn = false;
            return;
        }
        const procedureIOToken = token || Cookies.get(Settings.tokenCookieName);
        if (!procedureIOToken) {
            this.loggedIn = false;
            return;
        }
        try {
            this.userDetails = await this.getSelfUserDetails();
            if (this.userDetails) {
                dataStore.notificationsDataExpiration = Date.now() - 1;
                this.setLoginState();
            }
        } catch (e) {
            console.error(e);
            this.loggedIn = false;
            history.push(routes.LOGIN);

        }
    };

    setWorkspaceConfig = async () => {
        if ([sharedUtils.HP_LOGIN_DOMAIN, sharedUtils.HP_DEVICE_LOGIN_DOMAIN, sharedUtils.HP_API_DOMAIN].includes(this.workspace)) {
            this.workspaceIsHP = true;
            return
        }

        if ([sharedUtils.LOGIN_DOMAIN, sharedUtils.FAST_TRACK_DOMAIN, sharedUtils.DEVICE_LOGIN_DOMAIN].includes(this.workspace)) {
            this.workspaceIsHP = false;
            return
        }

        try {
            this.domainSettings = await GeneralRequester.getWorkspaceConfig(this.workspace);
            this.workspaceName = this.domainSettings.WorkspaceDisplayedName || this.workspace;
            this.initThemeValues(this.domainSettings.Theme);
            this.theme = this.domainSettings.Theme;
            Utility.applyWhiteLabelBranding(this.domainSettings.WhiteLabel);
            this.workspaceIsHP = !!this.domainSettings?.IsHP;
            this.isSitePrepEnabled = !!this.domainSettings?.SitePrepEnabled;
            this.activeDomainNames.set(this.workspace, this.domainSettings.UserSpecifiedName);
            this.isTranslationAiEnabled = !!this.domainSettings?.IsTranslationAiEnabled;
            this.isObjectDetectionEnabled = !!this.domainSettings?.IsObjectDetectionEnabled;
        } catch (e) {
            console.error(e);
            this.workspaceIsHP = false;
            this.isSitePrepEnabled = false;
        }
        //TODO check if domain is hp-domain before asking db
    }

    deployWorkspace = async (projectIdsList) => {
        await GeneralRequester.deployWorkspace(this.workspace, projectIdsList);
    }

    getDeployStatus = async () => {
        return await GeneralRequester.getDeployStatus(this.workspace);
    }

    getSelfUserDetails = async () => {
        // noinspection UnnecessaryLocalVariableJS
        const userDetails = await GeneralRequester.getSelfUserDetails();
        return userDetails;
    };
    updateUserLastLogin = async () => {
        await GeneralRequester.updateUserLastLoginDate(this.workspace);
    }
    updateUser = async (user) => {
        // noinspection UnnecessaryLocalVariableJS
        const status = await GeneralRequester.updateUser(user);
        return status;
    };


    logOut = async () => {
        const isHpLogout = this.workspaceIsHP || !!this.signInData.ssoAccessToken;
        const isHpCustomer = !!this.loggedIn ? !!this.userDetails.IsHpCustomer : !!this.signInData.isHpCustomer;
        this.loggedIn = false;
        Cookies.remove('session_active');
        clearInterval(this.dataPollInterval);
        this.stopOnlinePresence();
        if (this.tempFile && this.userDetails.UserIcon !== "default") {  //remove temp file URL from memory and reset user icon
            URL.revokeObjectURL(this.tempFile);
        }
        this.userDetails = {};
        const previousWorkspace = this.workspace;
        this.workspace = '';
        this.workspaceIsHP = false;
        this.getGlobalLanguageFromLocalStorage();
        this.resetLanguages();
        if (isEmbed) {
            Cookies.remove('workspace');
            window.location.href = routes.LOGOUT;
            return;
        }
        const {protocol, host} = window.location;

        const isDeviceLogin = !!this.deviceLoginCode || this.workspace === sharedUtils.DEVICE_LOGIN_DOMAIN || this.workspace === sharedUtils.HP_DEVICE_LOGIN_DOMAIN;
        let newHost;
        if (isDeviceLogin) {
            newHost = host.replace(`${previousWorkspace}.`, `${isHpLogout ? sharedUtils.HP_DEVICE_LOGIN_DOMAIN : sharedUtils.DEVICE_LOGIN_DOMAIN}.`);
        } else {
            newHost = host.replace(`${previousWorkspace}.`, `${isHpLogout ? sharedUtils.HP_LOGIN_DOMAIN : sharedUtils.LOGIN_DOMAIN}.`);
        }
        const hash = Settings.isNative ? '#' : '';
        const logoutUrlForHp = `${protocol}//${newHost}${hash}${routes.LOGOUT}`;
        const logoutUrl = `${protocol}//${newHost}${hash}${routes.LOGOUT}`;
        if (isHpLogout && isHpCustomer) {
            const ssoType = 'customer';
            const credentialsUrl = Settings.hp[ssoType].credentialsUrl;
            const hpLogoutUrl =
                ` https://${credentialsUrl}` + (!isHpCustomer ?
                    sharedUtils.HP_EMPLOYEE_LOGOUT_URL + `?post_logout_redirect_uri=https://reinvent.hp.com/HPxRServices&TargetResource=https://reinvent.hp.com/HPxRServices`
                    : `/directory/v1/oauth/logout?post_logout_redirect_uri=${logoutUrlForHp}&TargetResource=${logoutUrlForHp}&state=_openapp=${this.isOpenInApp ? 1 : 0}`);
            if (!isHpCustomer) {
                let newWindow = window.open(hpLogoutUrl);
                if (newWindow) {
                    setTimeout(function () {
                        newWindow.close();
                        window.open(logoutUrlForHp + `?openapp=${this.isOpenInApp ? 1 : 0}`);
                        window.close()
                    }, 5000);
                } else {
                    window.location.href = logoutUrlForHp + `?openapp=${this.isOpenInApp ? 1 : 0}`;
                    alert('Please allow popups for this site');
                }
                console.log('hp logout attepmted');
            } else {
                window.location.href = hpLogoutUrl;
            }
        } else {
            window.location.href = logoutUrl;
        }
        modalStore.silent = true;
    };

    goToLogin(toSignup) {
        const route = toSignup ? routes.SIGNUP : routes.LOGIN;
        if (isEmbed) {
            Cookies.remove('workspace');
            window.location.href = route;
            return;
        }
        let {host, protocol} = window.location;
        this.setWorkspaceConfig().then(() => {
            if (!this.workspace) {
                host = `${sharedUtils[this.workspaceIsHP ? "HP_LOGIN_DOMAIN" : "LOGIN_DOMAIN"]}.${host}`;   //if user is logging out from an hp workspace, assume he will log back in to an hp workspace
            }
            const hash = Settings.isNative ? '#' : '';
            window.location.href = `${protocol}//${host}${hash}${route}${window.location.search}`;
        });
    }

    deleteToken = () => {
        Cookies.remove(Settings.tokenCookieName);
        const {search} = window.location;
        history.push(routes.LOGIN + search);
    };

    getUploadLink = async (file, thumbnailData, storageFolderName, projectId, isAiFile) => {
        const {
            uploadUrl,
            fileUploadName,
            thumbnailUploadName,
            thumbnailUploadUrl
        } = await GeneralRequester.getSignedUploadUrl(file.name, !!thumbnailData, storageFolderName, this.workspace, projectId, !!this.oldMediaFileToBeReplaced, isAiFile);

        const chunks = Utility.getChunks(file);

        let thumbnailChunks = [];
        if (!!thumbnailData) {
            thumbnailChunks = Utility.getChunks(thumbnailData);
        }
        return {
            uploadUrl,
            chunks,
            thumbnailUploadUrl,
            thumbnailChunks,
            fileUploadName,
            thumbnailUploadName
        };

    }

    associateFile = async (file, fileUploadName, thumbnailUploadName, projectId, currentMediaFolder, storageFolderName, oldMediaFile, isAiUpload) => {
        // noinspection UnnecessaryLocalVariableJS
        const fileRecord = await GeneralRequester.associateFile(file.size, fileUploadName, file.name, thumbnailUploadName, projectId, currentMediaFolder, storageFolderName, this.workspace, oldMediaFile, isAiUpload);
        return fileRecord;
    }

    overrideFile = async (blob, file) => {
        const fileName = file.FileName + ' (edited).' + file.FileExtension;
        const projectId = file.ProjectRef;
        const currentMediaFolder = file.ParentFolder;
        blob.name = fileName;
        await this.uploadFiles([blob], projectId, currentMediaFolder);
    };

    uploadFile = async (file, totalChunks, uploadedCounter, projectId, currentFolderId, storageFolderName, oldMediaFile, i, isAiUpload) => {
        const thumbnailData = await Utility.getThumbnailData(file);

        if (Settings.isOnPrem) {
            const formData = new FormData();
            formData.append('file', file);
            if (thumbnailData) {
                formData.append('file', thumbnailData);
            }
            formData.append('data', JSON.stringify({
                fileName: file.name,
                projectId,
                currentFolderId,
                oldMediaFile
            }));

            const fileRecord = await GeneralRequester.uploadFileAndThumbnailLocal(formData, this.workspace);
            return fileRecord;
        }

        const {
            uploadUrl,
            chunks,
            thumbnailUploadUrl,
            thumbnailChunks,
            fileUploadName,
            thumbnailUploadName
        } = await this.getUploadLink(file, thumbnailData, storageFolderName, projectId, isAiUpload);
        const uploadChunksMethod = Settings.isGcloud ? this.uploadChunksGcloud : this.uploadChunksAzure;
        await uploadChunksMethod(file, chunks, totalChunks, uploadUrl, thumbnailChunks, thumbnailUploadUrl, thumbnailData, uploadedCounter, i);

        // noinspection UnnecessaryLocalVariableJS
        const associatedFile = await this.associateFile(
            file,
            fileUploadName,
            thumbnailUploadName,
            projectId,
            currentFolderId,
            storageFolderName,
            oldMediaFile,
            isAiUpload
        );
        return associatedFile;
    }
    uploadChunksGcloud = async (file, chunks, totalChunks, uploadUrl, thumbnailChunks, thumbnailUploadUrl, thumbnailData, uploadedCounter, index) => {
        for (const i in chunks) {
            if (!chunks.hasOwnProperty(i)) {
                continue;
            }
            const chunk = chunks[i];
            const firstByteIndex = i * UPLOAD_CHUNK_SIZE;
            const lastByteIndex = firstByteIndex + chunk.size - 1;
            await GeneralRequester.execUploadUrlGcloud(uploadUrl, chunk, firstByteIndex, lastByteIndex, file.size);
            uploadedCounter[0]++;
            this.updateProgressLoader(uploadedCounter[0], totalChunks, false, index);
        }
        if (!!thumbnailUploadUrl) {
            for (const i in thumbnailChunks) {
                if (!thumbnailChunks.hasOwnProperty(i)) {
                    continue;
                }
                const chunk = thumbnailChunks[i];
                const firstByteIndex = i * UPLOAD_CHUNK_SIZE;
                const lastByteIndex = firstByteIndex + chunk.size - 1;
                await GeneralRequester.execUploadUrlGcloud(thumbnailUploadUrl, chunk, firstByteIndex, lastByteIndex, thumbnailData.size);
            }
        }
    }
    uploadChunksAzure = async (file, chunks, totalChunks, uploadUrl, thumbnailChunks, thumbnailUploadUrl, thumbnailData, uploadedCounter, index) => {

        try {
            // Simple upload - upload entire file at once
            await GeneralRequester.execUploadUrlAzure(uploadUrl, file);

            // Update progress to 100%
            uploadedCounter[0] = totalChunks;
            this.updateProgressLoader(uploadedCounter[0], totalChunks, false, index);

            console.log('✅ Main file uploaded successfully');
        } catch (error) {
            console.error('❌ Main file upload failed:', error);
            throw error;
        }

        // Upload thumbnail if provided
        if (!!thumbnailUploadUrl && thumbnailData) {
            try {
                await GeneralRequester.execUploadUrlAzure(thumbnailUploadUrl, thumbnailData);
                console.log('✅ Thumbnail uploaded successfully');
            } catch (error) {
                console.error('❌ Thumbnail upload failed:', error);
                throw error;
            }
        }
    };

    uploadFiles = async (files, projectId, currentFolderId, storageFolderName, oldMediaFile, i) => {
        try {
            const filesAfterCompression = [];
            for (const file of files) {
                const fileAfterCompression = await Utility.shrinkFile(file);
                filesAfterCompression.push(fileAfterCompression)
            }

            const uploadedCounter = [0];
            const totalChunks = filesAfterCompression.reduce((accumulator, file) => Math.ceil(file.size / UPLOAD_CHUNK_SIZE) + accumulator, 0);
            this.isLoaderOpen = false;
            this.updateProgressLoader(uploadedCounter, totalChunks, false, i);
            const promises = filesAfterCompression.map(file => this.uploadFile(file, totalChunks, uploadedCounter, projectId, currentFolderId, storageFolderName, oldMediaFile, i, false));
            const associatedFiles = await Promise.all(promises);
            this.updateProgressLoader(100, 100, true, i);
            modalStore.showSuccessMessage(this.translate('filesUploadedSuccessfully') + '!', true);
            return associatedFiles;
        } catch (e) {

            this.updateProgressLoader(100, 100, true, i);
            throw e;
        }
    };


    updateProgressLoader = (uploaded, needToUpload, shouldClose = false, i) => {
        if (shouldClose) {
            this.progressLoaderValue = null;
            return;
        }
        const percentage = 100 * (uploaded / needToUpload);
        this.progressLoaderValue = percentage;
        this.progressLoaderString = `${this.translate('uploading')}: ${Math.floor(percentage)}%`;
        this.progressIndex = i;
    };

    deleteFile = async fileId => await GeneralRequester.deleteFile(fileId, this.workspace);
    deleteFolder = async mediaFolderId => await GeneralRequester.deleteFolder(mediaFolderId, this.workspace);
    deleteSessionMedia = async (fileId, procedureId) => await GeneralRequester.deleteSessionMedia(fileId, this.workspace, procedureId);

    renameMediaFolder = async (folderId, newName) => await GeneralRequester.renameMediaFolder(folderId, newName, this.workspace);
    renameFile = async (fileId, newName) => await GeneralRequester.renameFile(fileId, newName, this.workspace);

    searchUserSessions = async (userId, dateFilter, procedureFilters, recordingFilter, sortBy, sortDirection, pageNumber, batchNumber) => {
        const searchObj = {
            dateFilter, procedureFilters, recordingFilter, sortBy, sortDirection, pageNumber, batchNumber
        };
        return await GeneralRequester.adminSearchUserSessions(userId, searchObj, this.workspace)
    }

    searchUserRemoteSessions = async (userId, sortBy, sortDirection, pageNumber, batchNumber, dateFilter, recordingFilter, userFilters) => {
        const searchObj = {
            sortBy, sortDirection, pageNumber, batchNumber, dateFilter, recordingFilter, userFilters
        };
        return await GeneralRequester.adminSearchUserRemoteSessions(userId, searchObj, this.workspace)
    }

    getFileDownloadUrl = async (path, expiresIn) => {
        return await GeneralRequester.getFileDownloadUrl(this.workspace, path, expiresIn);
    }

    updatePlayerSettings = async (
        webBackgroundColorRight, webBackgroundColorLeft, webBackgroundImageAddress,
        webIsBackgroundColor, mobileBackgroundColorTop, mobileBackgroundColorBottom, mobileTopBarColor,
        mobileBottomBarColor, mobileBackgroundImageAddress, mobileIsBackgroundColor, qrLogoImageAddress,
        qrBorderColor, qrTopImageAddress
    ) => {
        await GeneralRequester.updatePlayerSettings(
            webBackgroundColorRight, webBackgroundColorLeft, webBackgroundImageAddress,
            webIsBackgroundColor, mobileBackgroundColorTop, mobileBackgroundColorBottom, mobileTopBarColor,
            mobileBottomBarColor, mobileBackgroundImageAddress, mobileIsBackgroundColor, qrLogoImageAddress,
            qrBorderColor, qrTopImageAddress, this.workspace
        );

        dataStore.playerSettingsDataExpiration = 0;
        dataStore.playerSettings = {
            webBackgroundColorRight,
            webBackgroundColorLeft,
            webBackgroundImageAddress,
            webIsBackgroundColor,
            mobileBackgroundColorTop,
            mobileBackgroundColorBottom,
            mobileTopBarColor,
            mobileBottomBarColor,
            mobileBackgroundImageAddress,
            mobileIsBackgroundColor,
            qrLogoImageAddress,
            qrBorderColor,
            qrTopImageAddress
        }
    };

    disconnectDevice = async (deviceIndex) => {
        return await GeneralRequester.disconnectDevice(this.signInData, deviceIndex);
    }

    removeDevice = async () => {
        await GeneralRequester.disconnectMyDevice(this.workspace);
    }
    canCreateProject = (user) => {
        const workspace = this.workspace;
        if (!user || !user.Domains || !user.Domains[workspace]) {
            return false;
        }
        return user.Domains[workspace].IsWorkspaceOwner || [contentCreatingRoleEnum.ADVANCED_CONTENT_CREATOR, contentCreatingRoleEnum.CONTENT_CREATOR].includes(user.Domains[workspace]?.Roles?.ContentCreationRole) || administrationRoleEnum.WORKSPACE_ADMIN === user.Domains[workspace]?.Roles?.AdministrationRole;
    }

    getAllNotifications = async () => {
        const isExpired = Date.now() > dataStore.notificationsDataExpiration;
        if (isExpired) {
            dataStore.notificationsDataExpiration = Date.now() + DATA_INTERVAL;
            dataStore.notifications.clear();
            try {
                const allNotifications = await GeneralRequester.getAllNotifications(this.workspace);
                if (!!allNotifications) {
                    this.populateNotificationData(allNotifications)
                }
            } catch (e) {
                console.log(e.message);
            }
        }
    };

    getNotificationHeader = notification => {
        if (!notification.HeaderKey) {
            return notification.Header
        } else return this.translate(notification.HeaderKey)
    }

    getNotificationDescription = notification => {
        if (!notification.DescriptionKeys || notification.DescriptionKeys.length === 0) {
            return notification.Description
        } else {
            const textKeys = notification.DescriptionKeys.map(key => {
                const keyIsVariable = key.slice(0, 2) === "$$";
                if (keyIsVariable) {
                    return key.slice(2)
                } else return this.translate(key)
            })
            return textKeys.join(' ')
        }
    }


    sendPushNotification = notification => {
        new Notification(
            `${this.translate('newNotificationSentence1_beforeName')} ${this.workspace} ${this.translate('newNotificationSentence2_afterName')}`,
            {
                body: Utility.removeHtmlTags(this.getNotificationDescription(notification)),
                icon: frontlineMobileLogo,
                requireInteraction: true,
                dir: this.langDir
            }
        ).onclick = () => {
            window.focus();
            this.openNotificationsPanel();
        }
        GeneralRequester.disablePush(this.workspace, notification._id).then()
    }

    populateNotificationData(allNotifications) {
        const notificationMap = new ObservableMap();
        allNotifications.forEach(notification => {
            if (notification.SendPushToDevice && notification.SendPushToDevice.Desktop) {
                this.sendPushNotification(notification)
                notification.SendPushToDevice.Desktop = false
            }
            notificationMap.set(notification._id, notification)
        })
        dataStore.notifications = notificationMap;
        localforage.setItem('notifications', JSON.stringify(dataStore.objectifyMap(notificationMap)))
            .then()
            .catch(e => console.error('could not store in localstorage', e));
    }

    get sortedNotifications() {
        const sorted = new ObservableMap();
        [...dataStore.notifications.values()].filter(n => this.filterByUnread(n)).forEach(notification => {
            const calenderDate = new Date(notification.CreatedIn).toDateString();
            if (sorted.has(calenderDate)) {
                sorted.get(calenderDate).push(notification)
            } else sorted.set(calenderDate, [notification]);
        })
        return sorted
    }

    filterByUnread = notification => {
        if (!this.userDetails.NotificationSettings || !this.userDetails.NotificationSettings.ShowUnread) {
            return true
        }
        switch (this.userDetails.NotificationSettings.ShowUnread) {
            case 1:
                return true;
            case 2:
                return notification.IsUnread;
            case 3:
                return !notification.IsUnread;
            default:
                return true
        }
    }

    openNotificationsPanel = () => {
        this.notificationsPanelOpen = true;
        this.notificationsSettingsOpen = false;
        this.notificationsSettingsCategoryIndex = 0;
    };
    closeNotificationPanel = () => this.notificationsPanelOpen = false;

    changeNotificationSettings = (prop, change) => {
        this.userDetails.NotificationSettings ? this.userDetails.NotificationSettings[prop] = change : this.userDetails.NotificationSettings = {[prop]: change};
        this.updateUser(this.userDetails).then();
    };

    get numUnreadNotifications() {
        return [...dataStore.notifications.values()].filter(n => n.IsUnread).length
    }

    markAllNotificationsRead = async () => {
        const updatedNotifications = await GeneralRequester.markAllNotificationsRead(this.workspace, this.numUnreadNotifications === 0)
        if (!!updatedNotifications) {
            dataStore.notificationsDataExpiration = Date.now() - 1;
            await this.getAllNotifications();
        }
    };

    updateNotification = (notification) => {
        GeneralRequester.updateNotification(this.workspace, notification).then(updatedNotification => {
            if (!!updatedNotification) {
                localforage.setItem('notifications', JSON.stringify(dataStore.objectifyMap(dataStore.notifications)))
                    .then()
                    .catch(e => console.error('could not store in localstorage', e));
            }
        })
    };

    toggleUnread = (notificationId, isUnread) => {
        const notification = dataStore.notifications.get(notificationId);
        notification.IsUnread = isUnread;
        GeneralRequester.toggleUnread(this.workspace, notificationId, isUnread).then(updatedNotification => {
            if (!!updatedNotification) {
                localforage.setItem('notifications', JSON.stringify(dataStore.objectifyMap(dataStore.notifications)))
                    .then()
                    .catch(e => console.error('could not store in localstorage', e));
            } else notification.IsUnread = !isUnread
        })
    };

    deleteManyNotifications = notifications => {
        notifications.forEach(n => dataStore.notifications.delete(n._id));
        GeneralRequester.deleteNotificationsFromDate(this.workspace, notifications.map(n => n._id)).then(success => {
            if (!!success) {     //if successful save datastore changes to localforage, otherwise add notifications back to datastore
                localforage.setItem('notifications', JSON.stringify(dataStore.objectifyMap(dataStore.notifications)))
                    .then()
                    .catch(e => console.error('could not store in localstorage', e));
            } else notifications.forEach(n => dataStore.notifications.set(n._id, n))
        })
    };

    deleteAllNotifications = async () => {
        const success = await GeneralRequester.deleteAllNotifications(this.workspace)
        if (!!success) {
            dataStore.notificationsDataExpiration = Date.now() - 1;
            await this.getAllNotifications();
        }
    };

    deleteNotification = notificationId => {
        const notification = {...dataStore.notifications.get(notificationId)}
        dataStore.notifications.delete(notificationId)
        GeneralRequester.deleteNotification(this.workspace, notificationId).then(success => {
            if (!!success) {     //if successful save datastore changes to localforage, otherwise add notification back to datastore
                localforage.setItem('notifications', JSON.stringify(dataStore.objectifyMap(dataStore.notifications)))
                    .then()
                    .catch(e => console.error('could not store in localstorage', e));
            } else dataStore.notifications.set(notificationId, notification)
        })
    };

    checkPreventLeave = () => {
        if (this.preventLeaveActive) {
            return !window.confirm(this.translate('confirmNavigateAwaySentence'))
        } else return false
    };

    get checkWorkspaceAdmin() {
        const {workspace, userDetails} = this;
        return sharedUtils.isUserAdmin(workspace, userDetails);
    }

    update3DAvatar = async (modelUrl, asRegularAvatar) => {
        const response = await fetch(modelUrl);
        const data = await response.blob();
        const metadata = {
            type: 'model/gltf-binary'
        };
        const modelFile = new File([data], this.userDetails._id + '.glb', metadata);
        const [fileData] = await this.uploadFiles([modelFile])
        this.userDetails = await GeneralRequester.update3DAvatar(fileData.FileId, asRegularAvatar);
    };

    delete3DAvatar = async () => {
        this.userDetails = await GeneralRequester.delete3DAvatar();
    };

    updateUserHand = async (isRight) => {
        this.userDetails = await GeneralRequester.updateUserHand(isRight);
    };

    turnOffRemindToPublish = procedureId => {
        const domainSettings = this.userCurrentDomainSettings || {};
        if (!domainSettings.DontShowRemindToPublish) {
            domainSettings.DontShowRemindToPublish = {
                [procedureId]: true
            }
        } else domainSettings.DontShowRemindToPublish[procedureId] = true;
        this.userDetails.Domains[this.workspace] = domainSettings;
        this.updateUser(this.userDetails).then();
    }

    getAllPayPerClicks = async includePending => {
        const filterObj = {
            creationDate: this.payPerClickSharing.creationDate,
            expirationDate: this.payPerClickSharing.expirationDate,
            status: this.payPerClickSharing.status,
            sortBy: this.payPerClickSharing.approvedSortBy,
            sortDirection: this.payPerClickSharing.approvedSortDirection,
            pageNumber: this.payPerClickSharing.pageNumber,
            batchNumber: batchOptions[this.payPerClickSharing.batchIndex],
            includePending
        };
        const result = await GeneralRequester.getAllPayPerClicks(this.workspace, filterObj);
        if (!result) {
            return false
        } else {
            this.payPerClickSharing.payPerClicks = result.approved || [];
            this.payPerClickSharing.total = result.total || 0;
            if (includePending) {
                this.payPerClickSharing.pendingPayPerClicks = result.pending || [];
            }
            return true
        }
    }
    checkPermission = async (permissionKey, accessScope) => {
        try {
            this.isLoaderOpen= true
            await GeneralRequester.checkPermissions(this.workspace, permissionKey, accessScope);
        } catch (err) {
            if ((err.response && err.response.status === 533) || err.code === 'ERR_BAD_RESPONSE') {
                window.location.href = '/logout';
            }
        } finally {
            this.isLoaderOpen = false
        }
    }
    addPayPerClickToApprovedList = updatedPayPerClick => {
        const inList = this.payPerClickSharing.payPerClicks.filter(payPerClick => payPerClick._id === updatedPayPerClick._id).length > 0;
        if (!inList) {
            this.payPerClickSharing.payPerClicks.unshift(updatedPayPerClick);
            this.payPerClickSharing.payPerClicks.pop();
        }
    }

    getPayPerClickSessions = async payPerClickId => {
        const filterObj = {
            startDate: this.payPerClickAnalytics.startDate,
            sortBy: this.payPerClickAnalytics.sortBy,
            sortDirection: this.payPerClickAnalytics.sortDirection,
            pageNumber: this.payPerClickAnalytics.pageNumber,
            batchNumber: batchOptions[this.payPerClickAnalytics.batchIndex],
        };
        const result = await GeneralRequester.getPayPerClickSessions(this.workspace, filterObj, payPerClickId);
        if (!result) {
            return false
        } else {
            this.payPerClickAnalytics.payPerClickSessions = result.sessions || [];
            this.payPerClickAnalytics.total = result.total || 0;
            return true
        }
    }

    getPayPerClickSessionsChartData = async (payPerClickId) => {
        const filterObj = {
            dateFrom: this.payPerClickAnalytics.dateFrom,
            dateTo: this.payPerClickAnalytics.dateTo,
            sessionsTranslation: this.translate('sessions')
        };
        const result = await GeneralRequester.getPayPerClickSessionsChartData(this.workspace, filterObj, payPerClickId);
        if (!result) {
            return false
        } else {
            this.payPerClickAnalytics.dailyData = result;
            this.payPerClickAnalytics.weeklyData = this.countViewsWeekly(result);
            this.payPerClickAnalytics.monthlyData = this.countViewsMonthly(result);
            return true
        }
    }

    countViewsWeekly = dailyData => {
        const weeklyDataMap = new Map();

        dailyData.forEach(dailyDataPoint => {
            const date = new Date(dailyDataPoint.time);
            date.setDate(date.getDate() - date.getDay());
            const dateOfSunday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            if (!weeklyDataMap.has(dateOfSunday)) {
                weeklyDataMap.set(dateOfSunday, dailyDataPoint[this.translate('sessions')]);
            } else {
                const counter = weeklyDataMap.get(dateOfSunday);
                weeklyDataMap.set(dateOfSunday, counter + dailyDataPoint[this.translate('sessions')]);
            }
        });
        const weeklyData = [];
        weeklyDataMap.forEach((sessions, dateOfSundayOfWeek) => {
            weeklyData.push({
                key: dateOfSundayOfWeek,
                [this.translate('sessions')]: sessions
            })
        });
        return weeklyData;
    }

    countViewsMonthly = dailyData => {
        const monthlyDataMap = new Map();
        dailyData.forEach(dailyDataPoint => {
            const date = new Date(dailyDataPoint.time);
            const monthName = `${date.getMonth() + 1}-${date.getFullYear()}`;
            if (!monthlyDataMap.has(monthName)) {
                monthlyDataMap.set(monthName, dailyDataPoint[this.translate('sessions')]);
            } else {
                const counter = monthlyDataMap.get(monthName);
                monthlyDataMap.set(monthName, counter + dailyDataPoint[this.translate('sessions')]);
            }
        });
        const monthlyData = [];
        monthlyDataMap.forEach((sessions, month) => {
            monthlyData.push({
                key: month,
                [this.translate('sessions')]: sessions
            })
        });
        return monthlyData;
    }

    saveAutoReportSettings = async settingsObj => {
        settingsObj.userEmail = this.userDetails.Email;
        const updatedAutoReports = await GeneralRequester.saveAutoReportSettings(this.workspace, settingsObj);
        if (!!updatedAutoReports) {
            this.userDetails.Domains[this.workspace].autoReports = updatedAutoReports;
            return true
        } else return false
    }

    populateAutoReports = async projectRef => {
        const settingsObj = {
            userEmail: this.userDetails.Email,
            projectRef
        }
        const autoReports = await GeneralRequester.getAutoReportSettings(this.workspace, settingsObj);
        if (!!autoReports?.length) {
            this.userDetails.Domains[this.workspace].autoReports = autoReports;
        } else this.userDetails.Domains[this.workspace].autoReports = [];
    }

    createQrCode = async (qrCodeName) => {
        return await GeneralRequester.createQrCode(this.workspace, qrCodeName);
    }

    getQrCodes = async (options) => {
        return await GeneralRequester.getQrCodes(this.workspace, options);
    }

    deleteQrCode = async (qrCodeId) => {
        return await GeneralRequester.deleteQrCode(this.workspace, qrCodeId);
    }

    updateQrCode = async (qrCodeId, qrCodeName) => {
        return await GeneralRequester.updateQrName(this.workspace, qrCodeId, qrCodeName);
    }

    updateQrUrlLink = async (shortUrlId, shortUrlLink) => {
        return await GeneralRequester.updateQrUrlLink(this.workspace, shortUrlId, shortUrlLink);
    }

    userIsWorkspaceAdminOrOwner = () => this.isWorkspaceOwner || this.isWorkspaceAdmin;

    getSubWorkspaceDisplayNames = async ()=>{
        if (this.subWorkspaceDisplayNamesMap.size === 0){
            const subWorkspaces = await GeneralRequester.getSubWorkspaceDisplayName(this.workspace)
            subWorkspaces.map(subWorkspace => this.subWorkspaceDisplayNamesMap.set(subWorkspace.DomainName, subWorkspace.WorkspaceDisplayedName))
        }
        return this.subWorkspaceDisplayNamesMap
        
    }
}
